import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { OpkraevningUdestaaendeSearchComponent } from './opkraevning-udestaaende-search/opkraevning-udestaaende-search.component';
import { OpkraevningUdestaaendeResultComponent } from './opkraevning-udestaaende-result/opkraevning-udestaaende-result.component';
import { OpkraevningUdestaaendeDetailComponent } from './opkraevning-udestaaende-detail/opkraevning-udestaaende-detail.component';
import { OpkraevningUdestaaendeService } from './opkraevning-udestaaende.service';

@Component({
  selector: 'app-risikoopkraevning-udestaaende',
  imports: [
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    ButtonModule,
    OpkraevningUdestaaendeSearchComponent,
    OpkraevningUdestaaendeResultComponent,
    OpkraevningUdestaaendeDetailComponent,
  ],
  templateUrl: './risikoopkraevning-udestaaende.component.html',
  styleUrl: './risikoopkraevning-udestaaende.component.css',
})
export class RisikoopkraevningUdestaaendeComponent {
  opkraevningUdestaaendeService = inject(OpkraevningUdestaaendeService);
  data = this.opkraevningUdestaaendeService.datasource.data;
}
